var _excluded = ["isTabletIncluded", "children"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled from "styled-components";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { pageGutterSpace } from "../../../settings";
import space from "../../../utils/space";
var StyledMobileGutterDestroyerOrg = styled.div.withConfig({
  componentId: "sc-rno58i-0"
})(["margin:0 ", ";"], space(-1 * pageGutterSpace));
function MobileGutterDestroyerOrg(_ref) {
  var isTabletIncluded = _ref.isTabletIncluded,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var isSmallOnly = useBreakpoint("small", "medium");
  var isMediumOnly = useBreakpoint("medium", "large");
  if (isSmallOnly || isMediumOnly && isTabletIncluded) {
    return /*#__PURE__*/React.createElement(StyledMobileGutterDestroyerOrg, restProps, children);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
export default MobileGutterDestroyerOrg;